/* eslint-disable import/prefer-default-export */
import {
  TravelAnalysisMessages,
  TranslationTravelAnalysisMessages
} from "../interfaces";

export const messages: TranslationTravelAnalysisMessages = {
  [TravelAnalysisMessages.pageTitle]: "Análise de Viagens",
  [TravelAnalysisMessages.filterButton]: "Filtrar",
  [TravelAnalysisMessages.loading]: "Carregando...",
  [TravelAnalysisMessages.totalAnalyzed]: "Total Analisado",
  [TravelAnalysisMessages.successfulTrips]: "Viagens com Sucesso",
  [TravelAnalysisMessages.successRate]: "Taxa de Sucesso",
  [TravelAnalysisMessages.alertsDetected]: "Alertas Detectados",
  [TravelAnalysisMessages.target]: "META",
  [TravelAnalysisMessages.alertDistributionTitle]: "Distribuição de Alertas por Tipo",
  [TravelAnalysisMessages.noAlertsInPeriod]: "Sem alertas no período",
  [TravelAnalysisMessages.successRatioTitle]: "Proporção Sucesso vs Alertas",
  [TravelAnalysisMessages.noData]: "Sem dados",
  [TravelAnalysisMessages.success]: "Sucesso",
  [TravelAnalysisMessages.alerts]: "Alertas",
  [TravelAnalysisMessages.efficiency]: "Eficiência",
  [TravelAnalysisMessages.geographicMonitoringTitle]: "Monitoramento Geográfico",
  [TravelAnalysisMessages.geographicMonitoringSubtitle]: "Distribuição de alertas por região de operação",
  [TravelAnalysisMessages.noGeographicData]: "Sem dados geográficos",
  [TravelAnalysisMessages.activeVehicles]: "Veículos Ativos",
  [TravelAnalysisMessages.activeAlerts]: "Alertas Ativos",
  [TravelAnalysisMessages.dashboardSubtitle]: "DASHBOARD DE OPERAÇÕES",
  [TravelAnalysisMessages.percentOfTotal]: "do total",
  [TravelAnalysisMessages.alertsListTitle]: "Detalhamento de Alertas",
  [TravelAnalysisMessages.columnVehicle]: "Veículo",
  [TravelAnalysisMessages.columnAlertType]: "Tipo de Alerta",
  [TravelAnalysisMessages.columnOrigin]: "Origem",
  [TravelAnalysisMessages.columnDestination]: "Destino",
  [TravelAnalysisMessages.columnDate]: "Data",
  [TravelAnalysisMessages.noAlertsFound]: "Nenhum alerta encontrado",
  [TravelAnalysisMessages.loadMore]: "Carregar mais",
  [TravelAnalysisMessages.close]: "Fechar",
  [TravelAnalysisMessages.tripsUnit]: "viagens",
  [TravelAnalysisMessages.columnNumDoc]: "Nº Doc",
  [TravelAnalysisMessages.columnActions]: "Ações",
  [TravelAnalysisMessages.viewAlertDetails]: "Detalhes do alerta",
  [TravelAnalysisMessages.viewTravel]: "Abrir viagem",
  [TravelAnalysisMessages.alertDetailsTitle]: "Detalhes da Análise",
  [TravelAnalysisMessages.loadingTravel]: "Carregando viagem...",
  // Metadata labels — CAN Data Stall
  [TravelAnalysisMessages.metaSource]: "Fonte de dados",
  [TravelAnalysisMessages.metaStallType]: "Tipo de travamento",
  [TravelAnalysisMessages.metaThreshold]: "Limiar",
  [TravelAnalysisMessages.metaStalledFields]: "Campos estagnados",
  [TravelAnalysisMessages.metaTotalCanPackets]: "Total de pacotes CAN",
  // Cross Day Cycle
  [TravelAnalysisMessages.metaStartDate]: "Data de início",
  [TravelAnalysisMessages.metaFinishDate]: "Data de fim",
  [TravelAnalysisMessages.metaStartDay]: "Dia de início",
  [TravelAnalysisMessages.metaFinishDay]: "Dia de fim",
  [TravelAnalysisMessages.metaDurationHours]: "Duração (horas)",
  // False Positive Discharge
  [TravelAnalysisMessages.metaTotalDischargeCommands]: "Total de comandos de descarga",
  [TravelAnalysisMessages.metaCoveredCommands]: "Comandos cobertos",
  [TravelAnalysisMessages.metaOrphanCommands]: "Comandos órfãos",
  [TravelAnalysisMessages.metaOrphanRatio]: "Taxa de órfãos (%)",
  [TravelAnalysisMessages.metaCoveredRanges]: "Períodos cobertos",
  // GPRS Connection Instability
  [TravelAnalysisMessages.metaTotalPackets]: "Total de pacotes",
  [TravelAnalysisMessages.metaMemoryCommands]: "Comandos offline real",
  [TravelAnalysisMessages.metaEffectiveRealtimeCommands]: "Comandos efetivamente tempo real",
  [TravelAnalysisMessages.metaRealtimeCommands]: "Comandos em tempo real",
  [TravelAnalysisMessages.metaMemoryRatio]: "Taxa de offline real (%)",
  [TravelAnalysisMessages.metaThresholdPercent]: "Limiar (%)",
  [TravelAnalysisMessages.metaEffectiveRealtimeThresholdSeconds]: "Limiar de tempo real efetivo (s)",
  [TravelAnalysisMessages.metaAvgDelaySeconds]: "Média de delay de transmissão (s)",
  [TravelAnalysisMessages.metaMaxDelaySeconds]: "Maior delay de transmissão (s)",
  // GPS Positioning Failure
  [TravelAnalysisMessages.metaTotalGpsPackets]: "Total de pacotes GPS",
  [TravelAnalysisMessages.metaInvalidFixCount]: "Posições inválidas",
  [TravelAnalysisMessages.metaInvalidRatio]: "Taxa de inválidos (%)",
  [TravelAnalysisMessages.metaAvgSatellites]: "Média de satélites",
  // Hardware Command Deficit
  [TravelAnalysisMessages.metaPacketCount]: "Pacotes recebidos",
  [TravelAnalysisMessages.metaExpectedPackets]: "Pacotes esperados",
  [TravelAnalysisMessages.metaMinimumRequired]: "Mínimo exigido",
  [TravelAnalysisMessages.metaDeficitPercent]: "Défice (%)",
  [TravelAnalysisMessages.metaRatePerMinute]: "Taxa por minuto",
  [TravelAnalysisMessages.metaTravelDurationMinutes]: "Duração da viagem (min)",
  // Logistics Flow Inconsistency
  [TravelAnalysisMessages.metaRequiredStates]: "Estados obrigatórios",
  [TravelAnalysisMessages.metaActualStates]: "Estados presentes",
  [TravelAnalysisMessages.metaMissingStates]: "Estados ausentes",
  [TravelAnalysisMessages.metaMissingCount]: "Quantidade em falta",
  [TravelAnalysisMessages.metaTotalStates]: "Total de estados",
  [TravelAnalysisMessages.metaNumDoc]: "Nº documento",
  // Sensor Command Deficit (IDLE)
  [TravelAnalysisMessages.metaIgnitionOnCount]: "Comandos com ignição ON",
  [TravelAnalysisMessages.metaIdleCount]: "Comandos em IDLE",
  [TravelAnalysisMessages.metaLoadingCount]: "Comandos carregando",
  [TravelAnalysisMessages.metaUnloadingCount]: "Comandos descarregando",
  [TravelAnalysisMessages.metaIdleRatio]: "Taxa de IDLE (%)",
  [TravelAnalysisMessages.successByDayTitle]: "Sucesso por Dia",
  [TravelAnalysisMessages.successByPlantTitle]: "Sucesso por Central",
  [TravelAnalysisMessages.successByRegionalTitle]: "Sucesso por Regional",
  [TravelAnalysisMessages.averageLine]: "Média",
  [TravelAnalysisMessages.noGroupedData]: "Sem dados para o período selecionado",
  [TravelAnalysisMessages.coordinateViewTitle]: "Visualização de Coordenadas",
  [TravelAnalysisMessages.coordinateViewVehicle]: "Veículo",
  [TravelAnalysisMessages.coordinateViewNF]: "NF",
  [TravelAnalysisMessages.coordinateViewGeneral]: "Geral",
  [TravelAnalysisMessages.coordinateViewContent]: "Conteúdo",
  [TravelAnalysisMessages.coordinateViewResult]: "Resultado",
  [TravelAnalysisMessages.coordinateViewGeneralData]: "Dados Gerais",
  [TravelAnalysisMessages.coordinateViewCommandContent]: "Conteúdo do Comando",
  [TravelAnalysisMessages.coordinateViewProcessingResult]: "Resultado do Processamento",
  [TravelAnalysisMessages.coordinateViewNoData]: "Sem dados",
  [TravelAnalysisMessages.coordinateViewField]: "Campo",
  [TravelAnalysisMessages.coordinateViewValue]: "Valor",
  // Alert glossary (help drawer)
  [TravelAnalysisMessages.glossaryButtonLabel]: "Sobre os alertas",
  [TravelAnalysisMessages.glossaryDrawerTitle]: "Entenda os Alertas de Viagem",
  [TravelAnalysisMessages.glossaryIntroTitle]: "Como funciona a análise",
  [TravelAnalysisMessages.glossaryIntroText]:
    "A análise é executada automaticamente assim que uma viagem é encerrada. Nesse momento, a viagem entra em uma fila e um processo em segundo plano reúne todos os seus dados — estados do veículo, eventos, coordenadas e os pacotes brutos recebidos do rastreador no período da viagem — e aplica as verificações abaixo. Cada verificação que identifica uma anomalia gera um alerta com seus detalhes. Viagens que não geram nenhum alerta são contabilizadas como sucesso na taxa exibida no painel.",
  [TravelAnalysisMessages.glossaryWhenLabel]: "Quando dispara",
  [TravelAnalysisMessages.glossaryAppliesLabel]: "Aplica-se a",
  [TravelAnalysisMessages.glossaryMetadataLabel]: "Detalhes capturados (metadados)",
  [TravelAnalysisMessages.glossaryAppliesAll]: "Todos os veículos",
  [TravelAnalysisMessages.glossaryAppliesMixerPump]: "Betoneiras e Caminhões-Bomba",
  [TravelAnalysisMessages.glossaryAppliesMixer]: "Betoneiras",
  [TravelAnalysisMessages.glossaryAppliesMixerDoc]: "Betoneiras com Nº documento (viagem de concreto)",
  // Glossary — GPRS Connection Instability
  [TravelAnalysisMessages.glossaryGprsTitle]: "Instabilidade de conexão GPRS",
  [TravelAnalysisMessages.glossaryGprsDesc]:
    "Indica que o rastreador perdeu o sinal de dados (GPRS) durante a viagem. Os pacotes capturados sem conexão ficam guardados na memória do equipamento e só chegam ao servidor quando o sinal volta, atrasados. Um volume alto desses pacotes atrasados sugere cobertura ruim ou problema na operadora/SIM, podendo deixar trechos sem rastro no trajeto.",
  [TravelAnalysisMessages.glossaryGprsWhen]:
    "Quando 30% ou mais dos pacotes chegaram atrasados da memória (atraso de transmissão de 60s ou mais). Pacotes de memória que chegam em menos de 60s são tratados como tempo real e não contam.",
  [TravelAnalysisMessages.glossaryGprsMeta]:
    "Os números mostram quantos pacotes vieram em tempo real, quantos vieram realmente atrasados da memória e o atraso médio e máximo de transmissão — quanto maior o atraso, pior estava o sinal.",
  // Glossary — GPS Positioning Failure
  [TravelAnalysisMessages.glossaryGpsTitle]: "Falha de posicionamento GPS",
  [TravelAnalysisMessages.glossaryGpsDesc]:
    "Indica que o equipamento não conseguiu obter uma posição confiável de satélite em boa parte da viagem. Pode ocorrer por obstrução (túneis, áreas fechadas), problema na antena ou poucos satélites visíveis, afetando a precisão do trajeto registrado.",
  [TravelAnalysisMessages.glossaryGpsWhen]:
    "Quando 30% ou mais dos pacotes com dados de GPS não tinham fixação válida de satélite (FIX inválido).",
  [TravelAnalysisMessages.glossaryGpsMeta]:
    "Mostram o total de pacotes GPS, quantos estavam sem fixação e a média de satélites captados — médias baixas reforçam a dificuldade de recepção.",
  // Glossary — Cross Day Cycle
  [TravelAnalysisMessages.glossaryCrossDayTitle]: "Ciclo transversal (D+1)",
  [TravelAnalysisMessages.glossaryCrossDayDesc]:
    "Aponta viagens que começaram em um dia e só terminaram no dia seguinte. Esse 'virar o dia' impacta o fechamento de produtividade diária, pois a viagem aparece em dois dias diferentes.",
  [TravelAnalysisMessages.glossaryCrossDayWhen]:
    "Quando o dia de início é diferente do dia de fim e a viagem durou 6 horas ou mais (viagens curtas que apenas cruzam a meia-noite são ignoradas).",
  [TravelAnalysisMessages.glossaryCrossDayMeta]:
    "Mostram as datas e os dias de início e fim, além da duração total da viagem em horas.",
  // Glossary — Hardware Command Deficit
  [TravelAnalysisMessages.glossaryHwDeficitTitle]: "Déficit de comandos de hardware enviados",
  [TravelAnalysisMessages.glossaryHwDeficitDesc]:
    "Indica que o rastreador transmitiu menos pacotes do que o esperado para a duração da viagem. Pode sinalizar equipamento com falha, desligado parte do tempo ou com problema de transmissão, reduzindo a confiabilidade dos dados da viagem.",
  [TravelAnalysisMessages.glossaryHwDeficitWhen]:
    "Quando o número de pacotes recebidos ficou abaixo de 50% do esperado (referência de 1 pacote a cada 2 minutos). Avaliado apenas em viagens com mais de 5 minutos.",
  [TravelAnalysisMessages.glossaryHwDeficitMeta]:
    "Comparam os pacotes recebidos com os esperados e mostram o déficit percentual e a taxa de pacotes por minuto.",
  // Glossary — Sensor Command Deficit (IDLE)
  [TravelAnalysisMessages.glossarySensorIdleTitle]: "Déficit de comandos de sensor ativo (IDLE elevado)",
  [TravelAnalysisMessages.glossarySensorIdleDesc]:
    "Indica que, com o veículo ligado, o balão (tambor) ficou parado — sem carregar nem descarregar — durante boa parte da viagem. Pode apontar sensor do balão com falha ou problema de comunicação, prejudicando a leitura das etapas de carga e descarga.",
  [TravelAnalysisMessages.glossarySensorIdleWhen]:
    "Quando, entre os pacotes com ignição ligada, 50% ou mais estavam com o balão parado (IDLE). Avaliado com pelo menos 10 pacotes de ignição ligada.",
  [TravelAnalysisMessages.glossarySensorIdleMeta]:
    "Mostram quantos pacotes tinham ignição ligada e, desses, quantos estavam carregando, descarregando ou parados (IDLE).",
  // Glossary — Logistics Flow Inconsistency
  [TravelAnalysisMessages.glossaryLogisticsTitle]: "Inconsistência de fluxo logístico",
  [TravelAnalysisMessages.glossaryLogisticsDesc]:
    "Aponta viagens de concreto que não passaram por todos os estados esperados do ciclo (Na usina → A caminho → Em obra → Descarregando → Retornando). A ausência de um estado pode indicar falha de detecção, trajeto atípico ou problema no apontamento da viagem.",
  [TravelAnalysisMessages.glossaryLogisticsWhen]:
    "Quando falta pelo menos um dos estados obrigatórios. Verifica a presença de cada estado, não a ordem.",
  [TravelAnalysisMessages.glossaryLogisticsMeta]:
    "Listam os estados obrigatórios, os que ocorreram e os que ficaram faltando na viagem.",
  // Glossary — CAN Data Stall
  [TravelAnalysisMessages.glossaryCanStallTitle]: "Informações de CAN travadas (completas ou parciais)",
  [TravelAnalysisMessages.glossaryCanStallDesc]:
    "Indica que dados vindos do barramento CAN do veículo (velocidade, RPM, combustível, odômetro) ficaram 'congelados', repetindo o mesmo valor por vários pacotes seguidos. Costuma apontar falha na leitura do CAN, prejudicando a telemetria do veículo.",
  [TravelAnalysisMessages.glossaryCanStallWhen]:
    "Quando algum campo do CAN repete o mesmo valor por 10 pacotes consecutivos ou mais. 'Total' = todos os campos congelados; 'Parcial' = ao menos um campo congelado.",
  [TravelAnalysisMessages.glossaryCanStallMeta]:
    "Mostram quais campos travaram, por quantos pacotes seguidos e o valor que ficou repetido.",
  // Glossary — False Positive Discharge
  [TravelAnalysisMessages.glossaryFalseDischargeTitle]: "Falsos positivos de descarga",
  [TravelAnalysisMessages.glossaryFalseDischargeDesc]:
    "Aponta comandos de descarga do balão que ocorreram fora de qualquer contexto válido de descarregamento (sem estar descarregando, na usina, em local confiável ou em evento de descarregamento indevido). Esses comandos 'órfãos' podem ser ruído de sensor ou descargas não detectadas corretamente.",
  [TravelAnalysisMessages.glossaryFalseDischargeWhen]:
    "Quando há 3 ou mais comandos de descarga órfãos (não cobertos por nenhum período de descarga conhecido).",
  [TravelAnalysisMessages.glossaryFalseDischargeMeta]:
    "Mostram o total de comandos de descarga, quantos estavam cobertos por um contexto válido e quantos ficaram órfãos."
};
